/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import useSWR from "swr";

import { dbFirestore } from "../../firestore";
import { modalActions } from "../../modules/modal";
import { useSelector } from "../../store";
import {
  getSelectedRedeemGroupIds,
  setSelectedRedeemGroupIds,
} from "./useSelectedRedeemTicketIds";

import type { TicketRedeemGroup } from "../../firestore/types";

const fetchRedeemGroups = async (): Promise<TicketRedeemGroup[]> => {
  const snapshot = await dbFirestore.ticketRedeemGroups().get();
  return snapshot.docs.map((doc) => doc.data()).filter((data) => data !== null);
};

const QrcodeReaderSetting: React.FC = () => {
  const dispatch = useDispatch();
  const isOpenError = useSelector((state) => state.modal.isOpenError);
  const { data: redeemGroups, error: redeemGroupsError } = useSWR<
    TicketRedeemGroup[],
    Error
  >("redeemGroups", fetchRedeemGroups);
  const [selectedIds, setSelectedIds] = useState<string[]>(
    getSelectedRedeemGroupIds
  );

  useEffect(() => {
    if (redeemGroupsError && !isOpenError) {
      dispatch(
        modalActions.toggleError({
          msg: "もぎりグループの取得に失敗しました",
        })
      );
    }
  }, [redeemGroupsError, isOpenError, dispatch]);

  const handleToggle = (id: string) => {
    setSelectedIds((prev) => {
      const next = prev.includes(id)
        ? prev.filter((v) => v !== id)
        : [...prev, id];
      setSelectedRedeemGroupIds(next);
      return next;
    });
  };

  if (redeemGroups === undefined) {
    return <p>読み込み中...</p>;
  }

  return (
    <div css={styles.root}>
      <p>設定</p>
      {redeemGroups.map((group) => (
        <label key={group._id} css={styles.item}>
          <input
            type="checkbox"
            checked={selectedIds.includes(group._id)}
            onChange={() => handleToggle(group._id)}
          />
          <span>{group.name}</span>
        </label>
      ))}
    </div>
  );
};

export default QrcodeReaderSetting;

const styles = {
  root: css({
    padding: 20,
    color: "#fff",
  }),
  item: css({
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "12px 0",
    cursor: "pointer",
  }),
};
